import React, { useRef } from 'react';
import { ArrowLeft, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../app/layouts/MainLayout';
import { Button } from '../../../components/ui/Button';
import GeneralSettingsPanel, { GeneralSettingsPanelRef } from '../components/GeneralSettingsPanel';
import { useTrimesters } from '../context/TrimestersContext';

const SegmentsPage: React.FC = () => {
  const navigate = useNavigate();
  const settingsPanelRef = useRef<GeneralSettingsPanelRef>(null);
  const { trimesters, currentTrimesterId } = useTrimesters();

  const sortedTrimesters = [...trimesters].sort((a, b) =>
    a.year === b.year ? b.number - a.number : b.year - a.year
  );

  return (
    <MainLayout>
      <div className="space-y-6">
        <button
          type="button"
          onClick={() => navigate('/mais')}
          className="flex items-center gap-2 text-sm font-semibold text-slate-600"
        >
          <ArrowLeft size={18} /> Voltar
        </button>

        <div className="flex items-start justify-between gap-3">
          <div>
            <h2 className="text-2xl font-bold text-slate-900">Segmentos</h2>
            <p className="text-sm text-gray-500">Cadastre os segmentos usados por turmas e revistas.</p>
          </div>
          <Button className="h-12 gap-2 px-4" onClick={() => settingsPanelRef.current?.openCreateSegment()}>
            <Plus size={18} />
            Novo segmento
          </Button>
        </div>

        <GeneralSettingsPanel
          ref={settingsPanelRef}
          trimesters={sortedTrimesters}
          currentTrimesterId={currentTrimesterId}
          mode="segments"
          showHeader={false}
          showSegmentCreateButton={false}
        />
      </div>
    </MainLayout>
  );
};

export default SegmentsPage;
